import { render, staticRenderFns } from "./AdminServices.vue?vue&type=template&id=38a30514"
import script from "./AdminServices.vue?vue&type=script&lang=js"
export * from "./AdminServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports